import { Injectable } from '@angular/core';
// import { AES, enc, mode } from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class CryptoService {

  private static readonly CIPHER_KEY: string = atob('MTIzNDU2Nzg5MDEyMzQ1Ng==');

  constructor() { }

  // public AES_encrypt(text: string): string {
  //   let secret = enc.Utf8.parse(CryptoService.CIPHER_KEY);
  //   let rawData = AES.encrypt(text, secret, { mode: mode.ECB });

  //   return rawData.toString();
  // }

  // public AES_decrypt(text: string): string {
  //   let cipheredData: any = { ciphertext: enc.Base64.parse(text) };
  //   let secret = enc.Utf8.parse(CryptoService.CIPHER_KEY);
  //   let rawData = AES.decrypt(cipheredData, secret, { mode: mode.ECB });

  //   return rawData.toString(enc.Utf8);
  // }

  // public MD5_hash(text: string): string {
  //   return Md5.init(text);
  // }
}
